import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useScreen, useUserData } from '../../../hooks'
import { isStaffUser } from '../../../utils/user'
import { useCloseConfirm } from '../../Form'
import {
  MINIMIZED_MODAL_KEY,
  useMinimizableModal,
  useResizeModal,
} from '../../Modal'
import { REQUEST_MINIMIZED_REPLACE_CONFIRMATION } from '../Request.constants'
import {
  useRequestDraftCloseConfirmation,
  useRequestWizardDraft,
} from '../Request.hooks'
import { RequestWizardForm } from '../RequestWizardForm'
import { RequestWizardFormPopupContainer } from '../RequestWizardFormPopupContainer'

import { QA_NAME_MODAL_WIZARD } from './RequestWizardFormModal.constants'

import * as styles from './RequestWizardFormModal.module.css'

function RequestWizardFormModal({
  minimizedModalScope,
  title = 'Modal.WizardNewRequestTitleKey',
  onClose,
  ...restProps
}) {
  const { t } = useTranslation()

  const currentUser = useUserData()
  const isStaffUserAcc = isStaffUser(currentUser)

  const [modal, setModal] = useState(null)

  const { handleClose, isCloseConfirm, setCloseConfirm } = useCloseConfirm({
    onClose,
  })

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  const { fullScreen, handleResizeModal } = useResizeModal()

  const { draftId, setDraft } = useRequestWizardDraft()

  const closeConfirmation = useRequestDraftCloseConfirmation(setDraft)

  const { handleMinimize, isMinimized, setIsDirty } = useMinimizableModal({
    closeConfirmation,
    minimizeKey: MINIMIZED_MODAL_KEY.REQUEST_WIZARD_FORM,
    qaName: QA_NAME_MODAL_WIZARD,
    replaceConfirmation: REQUEST_MINIMIZED_REPLACE_CONFIRMATION,
    scope: minimizedModalScope,
    sourceId: draftId,
    title: t(title),
    onClose,
  })

  const initStageFormFieldsProps = !isStaffUserAcc
    ? {
        userFieldProps: {
          controlProps: {
            className: styles.disabledPointerEvents,
            indicatorsProps: {
              ButtonArrow: null,
              ButtonClear: null,
            },
          },
        },
      }
    : undefined

  return (
    <RequestWizardForm
      {...restProps}
      FormContainer={RequestWizardFormPopupContainer}
      containerProps={{
        confirmationProps: {
          description: 'Modal.WizardCloseConfirmationTextKey',
        },
        hidden: isMinimized,
        isCloseConfirm,
        isFullScreen: isMobileScreenSize || fullScreen,
        modal,
        qaName: QA_NAME_MODAL_WIZARD,
        setCloseConfirm,
        title,
        onClose,
        onIsDirtyChange: setIsDirty,
        onMinimize: handleMinimize,
        onResize: isMobileScreenSize // to switch off the resize button on responsive mode
          ? undefined
          : handleResizeModal,
      }}
      contentComponentProps={{
        isFullScreen: isMobileScreenSize || fullScreen,
      }}
      initStageFormFieldsProps={initStageFormFieldsProps}
      setModal={setModal}
      onCancel={handleClose}
      onCardStageClose={() => {
        setCloseConfirm(true)
      }}
      onClose={onClose}
    />
  )
}

export default RequestWizardFormModal
